























/* eslint-disable */
import getUrlParam from '@/common/utils/getUrlParam';
import CONFIG from "@/common/config";


import fetch from "@/common/api/fetch";
import { Component, Vue, Mixins } from "vue-property-decorator";
import PageInitialMixin from "@/mixins/PageInitialMixin";
import { Getter, Action } from "vuex-class";
import Profile from './Profile.vue'
import BottomInfo from './BottomInfo.vue'
import { AxiosPromiseData } from "@/common/interface";
@Component({
  components: {
    "Profile": Profile,
    "bottom-info": BottomInfo,
  },
})
export default class Activity extends Vue {

  @Getter("openId") openId!: string;
  @Getter("contactQrcode") contactQrcode!: string;
  @Getter("title") title!: string;
  @Getter("instName") instName!: string;
  @Getter("deadline") deadline!: string;
  @Getter("activityRule") activityRule!: string;
  @Getter("instAddress") instAddress!: string;
  @Getter("instPhone") instPhone!: string;
  @Getter("institutionIntros") institutionIntros!: Array<object>;
  @Action("changeShowFooter") changeShowFooter!: Function;
  broadcastId: string = getUrlParam("broadcastId") as string;
  isCopy: boolean = false;
  isFromDistribute: boolean = true;
  message: object = {};
  hidden: boolean = false;
  again: boolean = false;
  created() {
    const isCopy = getUrlParam('state') == 'copy';
    this.isCopy = isCopy;
    this.dealData();
  }
  mounted() {
    if(getUrlParam('type')=='share'||getUrlParam('type')=='check') {
    }
  }
  hiddenKeyboard(evt: Event): void {
    (document.activeElement as HTMLElement).blur();
  }
  dealData(): void {
      this.message = {
        contactQrcode:this.contactQrcode,
        title:this.title,
        instName:this.instName,
        deadline:this.deadline,
        activityRule:this.activityRule,
        instAddress:this.instAddress,
        instPhone:this.instPhone,
        institutionIntros:this.institutionIntros,
      }
      console.log(this.message);
  }
  goNext():void {
    let url = `/pages/ask-info/index?openid=${this.$store.state.openId}`
    console.log('redirect', url);
    window.wx.miniProgram.redirectTo({
        url,
    });
  }
}
